import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientesService } from "app/core/services/clientes/clientes.service";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { esLocale } from "ngx-bootstrap/locale";
import { defineLocale } from "ngx-bootstrap/chronos";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-add-other-credit",
  templateUrl: "./add-other-credit.component.html",
  styleUrls: ["./add-other-credit.component.css"],
})
export class AddOtherCreditComponent implements OnInit {
  public myForm: FormGroup;
  public credit: any;
  public tiposCreditos: any[];
  public entidadesFinancieras: any[];
  public monedas: any[];
  faTimes=faTimes;
  @Input() clienteId = 0;
  @Input() creditId = 0;

  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private clientesService: ClientesService,
    public formbuild: FormBuilder,
    public activeModal: NgbActiveModal,
    public localeService: BsLocaleService
  ) {
    defineLocale("es", esLocale);
    this.localeService.use("es");
    this.initForm();
  }

  ngOnInit(): void {
    if (this.creditId) {
      this.obtenerOtroCredito();
    }

    let tiposCreditos = this.clientesService.obtenerTiposCreditos();
    let entidadesFinancieras = this.clientesService.obtenerEntidadesFinancieras();
    let monedas = this.clientesService.obtenerListaMonedas();

    Promise.all([tiposCreditos, entidadesFinancieras, monedas]).then((res) => {
      this.tiposCreditos = res[0]["results"];
      this.entidadesFinancieras = res[1]["results"];
      this.monedas = res[2]["results"];
    });
  }

  obtenerOtroCredito() {
    this.clientesService
      .obtenerOtroCredito(this.creditId)
      .then((res) => {
        this.credit = res;
        this.setForm(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  initForm() {
    this.myForm = this.formbuild.group({
      tipo_credito: [null, [Validators.required]],
      entidad_financiera: [null, [Validators.required]],
      plazo: [null, []],
      monto: [null, [Validators.required]],
      moneda: [null, [Validators.required]],
      vencimiento_primera_cuota: [null, []],
      vencimiento_ultima_cuota: [null, []],
      cuotas_pagadas: [null, []],
    });
  }

  get f() {
    return this.myForm.controls;
  }

  setForm(item) {
    for (const key in item) {
      if (this.myForm.controls[key]) {
        if (
          key === "vencimiento_primera_cuota" ||
          key === "vencimiento_ultima_cuota"
        ) {
          this.myForm.controls[key].setValue(this.parseDate(item[key]));
        } else this.myForm.controls[key].setValue(item[key]);
      }
    }
  }

  onSubmit() {
    if (this.myForm.valid) {
      const data = this.myForm.value;
      data["cliente"] = this.clienteId;
      data["vencimiento_primera_cuota"] = this.formatDate(
        this.myForm.value["vencimiento_primera_cuota"]
      );
      data["vencimiento_ultima_cuota"] = this.formatDate(
        this.myForm.value["vencimiento_ultima_cuota"]
      );

      this.clientesService
        .guardarOtroCredito(this.myForm.value, this.creditId)
        .then((res) => {
          this.successEmit.emit();
          this.activeModal.close(false);
        })
        .catch((error) => {
          this.activeModal.close(false);
        });
    }
  }

  formatDate(date) {
    if (!(date instanceof Date)) return;

    return (
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    );
  }

  parseDate(date) {
    if (!date) return null;

    let dateNow = new Date();

    let yy = date.split("-")[0];
    let mm = date.split("-")[1] - 1;
    let dd = date.split("-")[2];

    let d = new Date(yy, mm, dd, dateNow.getHours());
    return d;
  }
  compararTipos(tipo1: any, tipo2: any) {
    return tipo1 && tipo2 ? tipo1.id === tipo2 : tipo1 === tipo2;
  }
}
